import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { PageService } from '@karve.it/features';
import { CreatePageInput, Page } from '@karve.it/interfaces/pages';
import * as _ from 'lodash';
import { ValidationItem } from 'src/app/app.component';
import { SubSink } from 'subsink';

interface CreatePageValidation {
  title: ValidationItem;
  path: ValidationItem;
}

@Component({
  selector: 'app-create-page',
  templateUrl: './create-page.component.html',
  styleUrls: ['./create-page.component.scss']
})
export class CreatePageComponent implements OnInit, OnDestroy {

 @Output() createdPage = new EventEmitter<Page>();

 @Input() pathLocked = false;

  subs = new SubSink();

  defaultCreatePageValidation = {
    title: {
       touched: false,
       valid: false,
    },
    path: {
      touched: false,
      valid: false,
   }
  };
  createPageValidation: CreatePageValidation = _.cloneDeep(this.defaultCreatePageValidation);
  createPageDialogVisible = false;
  defaultCreatePageInput = {page: {title: '', attributes: [], blocks: [], path: ''}};
  createPageInput: CreatePageInput = _.cloneDeep(this.defaultCreatePageInput);



  constructor(private router: Router,
              private pageService: PageService) { }

  ngOnInit(): void {
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }



  openCreatePageDialog(){
    this.createPageDialogVisible = true;
    if (this.createPageInput.page) {
      if (this.pathLocked) {
        this.createPageInput.page.path = this.router.url;
        this.createPageValidation.path.valid = true;
      }
    }
  }

  // Creates a Page with this route
  // createPage() {
  //   this.pageService.createPage({page: this.createPageInput.page}).subscribe((res) => {
  //     console.log(res);
  //     if (res.data?.createPage){
  //       this.createdPage.emit(res.data.createPage);
  //       this.createPageDialogVisible = false;

  //       // Reset the values for next time.
  //       this.createPageInput = _.cloneDeep(this.DEFAULT_CREATE_PAGE_INPUT);
  //       this.createPageValidation = _.cloneDeep(this.DEFAULT_CREATE_PAGE_VALIDATION);
  //     }
  //   })
  // }


  // Validation

  validate(field: 'title' | 'path') {
    if (!this.createPageInput.page) { return; }
    switch (field){
      case 'title':
        this.createPageValidation.title.valid = this.createPageInput.page?.title.length >= 1;
        break;

      case 'path':
        // The Rest of this validation will be handled on the backend
        this.createPageValidation.path.valid = this.createPageInput.page.path.length >= 1;
        break;
    }
  }

  focusOut(field: 'title' | 'path') {

    switch(field){
      case 'title':
        this.createPageValidation.title.touched = true;
        break;

      case 'path':
        this.createPageValidation.path.touched = true;
        break;
    }
  }

}
